import { useSidebar } from '@/app/providers/SidebarProvider';

const Backdrop: React.FC = () => {
    const { isMobileOpen, toggleMobileSidebar } = useSidebar();

    if (!isMobileOpen) return null;

    return (
        <div
            className="fixed inset-0 z-40 bg-mp-overlay lg:hidden"
            onClick={toggleMobileSidebar}
        />
    );
};

export default Backdrop;
